import React from "react";
import desafio from "../../assets/12_Quienes somos/Sobre nosotros/hyundai-valor-desafio.svg";
import colaboracion from "../../assets/12_Quienes somos/Sobre nosotros/hyundai-valor-colaboracion.svg";
import cliente from "../../assets/12_Quienes somos/Sobre nosotros/hyundai-valor-cliente.svg";
import globalidad from "../../assets/12_Quienes somos/Sobre nosotros/hyundai-valor-globalidad.svg";
import gente from "../../assets/12_Quienes somos/Sobre nosotros/hyundai-valor-gente.svg";
import banner from "../../assets/12_Quienes somos/Sobre nosotros/sobre-nosotros-valores-institucionales.webp";

/*eslint-disable */

declare const window: any;
const ValoresComponent: React.FC = () => {
  return (
    <div className="nuestro-valores" style={{ backgroundImage: `url(${banner})` }}>
      {/* H2 - Título de la sección */}
      <h2 className="title">Valores institucionales</h2>
      
      <div className="row justify-content-center">
        <div className="col-xl-2 col-lg-3 col-md-4 col-sm-12 mb-4">
          <div className="intitucionales">
            <img className="logo" src={desafio} alt="Icono del valor Desafío de Hyundai" />
            {/* H3 - Nombre del valor */}
            <h3 className="title">Desafío</h3>
            {/* H4 - Descripción del valor */}
            <h4 className="description">Nos negamos a ser conformistas, aprovechamos cada desafío y confiamos en que alcanzaremos nuestras metas con pasión e ingenio.</h4>
          </div>
        </div>
        
        <div className="col-xl-2 col-lg-3 col-md-4 col-sm-12 mb-4">
          <div className="intitucionales">
            <img className="logo" src={colaboracion} alt="Icono del valor Colaboración de Hyundai" />
            {/* H3 - Nombre del valor */}
            <h3 className="title">Colaboración</h3>
            {/* H4 - Descripción del valor */}
            <h4 className="description">Creamos sinergia con una comunicación mutua y cooperación genuina entre la compañía y nuestros socios.</h4>
          </div>
        </div>
        
        <div className="col-xl-2 col-lg-3 col-md-4 col-sm-12 mb-4">
          <div className="intitucionales">
            <img className="logo" src={cliente} alt="Icono del valor Cliente de Hyundai" />
            {/* H3 - Nombre del valor */}
            <h3 className="title">Cliente</h3>
            {/* H4 - Descripción del valor */}
            <h4 className="description">Promovemos una cultura centrada en el cliente, brindando calidad y servicios impecables.</h4>
          </div>
        </div>
        
        <div className="col-xl-2 col-lg-3 col-md-4 col-sm-12 mb-4">
          <div className="intitucionales">
            <img className="logo" src={globalidad} alt="Icono del valor Globalidad de Hyundai" />
            {/* H3 - Nombre del valor */}
            <h3 className="title">Globalidad</h3>
            {/* H4 - Descripción del valor */}
            <h4 className="description">Impulsamos un enfoque global, conectando personas y mercados con innovación y calidad, para brindar soluciones sin fronteras.</h4>
          </div>
        </div>
        
        <div className="col-xl-2 col-lg-3 col-md-4 col-sm-12 mb-4">
          <div className="intitucionales">
            <img className="logo" src={gente} alt="Icono del valor Gente de Hyundai" />
            {/* H3 - Nombre del valor */}
            <h3 className="title">Gente</h3>
            {/* H4 - Descripción del valor */}
            <h4 className="description">Creemos en el potencial de nuestros miembros y fomentamos una cultura que respete y desarrolle su talento.</h4>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ValoresComponent;